import { NavLink } from 'react-router-dom';
import { logo } from './auth.constants';

export default function AuthenticationNavBar() {
  return (
    <NavLink
      className={'navbar navbar-brand p-0 m-0 ms-4'}
      to={'/login'}
    >
      {logo}
    </NavLink>
  );
}
